import React from "react";
import { observer } from "mobx-react";
import { ContractObservationCreateStore } from "../../store";
import { ContractObservationCreateForm } from "./ContractObservationCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type ContractObservationCreateProps = {
  contractObservationCreateStore: ContractObservationCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ContractObservationCreate: React.FC<ContractObservationCreateProps> =
  observer(
    ({
      contractObservationCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={contractObservationCreateStore.isSaving} />
          <ContractObservationCreateForm
            contractObservationCreateStore={contractObservationCreateStore}
            titleError={contractObservationCreateStore.errors.title?.message}
            onTitleChange={(value: string) => {
              contractObservationCreateStore.setTitleValue(value);
            }}
            title={contractObservationCreateStore.entityValues.title}
            observationError={
              contractObservationCreateStore.errors.observation?.message
            }
            onObservationChange={(value: string) => {
              contractObservationCreateStore.setObservationValue(value);
            }}
            observation={
              contractObservationCreateStore.entityValues.observation
            }
            requireAllError={
              contractObservationCreateStore.errors.requireAll?.message
            }
            onRequireAllChange={(value: boolean) => {
              contractObservationCreateStore.setRequireAllValue(value);
            }}
            requireAll={contractObservationCreateStore.entityValues.requireAll}
            authorsError={
              contractObservationCreateStore.errors.authors?.message
            }
            onAuthorsChange={(value) => {
              contractObservationCreateStore.setAuthorsValue(value);
            }}
            authorsSelectedValues={
              contractObservationCreateStore.entityValues.showAuthors
            }
            onAuthorsSelected={(value) => {
              contractObservationCreateStore.setSelectedAuthors(value);
            }}
            authorsOptions={contractObservationCreateStore.getAuthorsOptions()}
            publishersError={
              contractObservationCreateStore.errors.publishers?.message
            }
            onPublishersChange={(value) => {
              contractObservationCreateStore.setPublishersValue(value);
            }}
            publishersSelectedValues={
              contractObservationCreateStore.entityValues.showPublishers
            }
            onPublishersSelected={(value) => {
              contractObservationCreateStore.setSelectedPublishers(value);
            }}
            publishersOptions={contractObservationCreateStore.getPublishersOptions()}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={contractObservationCreateStore.isProcessing}
            onSave={() =>
              contractObservationCreateStore.saveNewContractObservation()
            }
            onCancel={() =>
              contractObservationCreateStore.cancelNewContractObservation()
            }
          />
          <ErrorDialog
            open={contractObservationCreateStore.errorDialogOpened}
            title={contractObservationCreateStore.errorTitle}
            description={contractObservationCreateStore.errorDescription}
            onClose={() => contractObservationCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
